

const NodeType = Object.freeze({
    LIFT:   "lift",
});

class Rules {

	constructor() {
      	this.name = 'Rules';
      	this.type;
      	this.selectedFloors;
      	this.escalator;
  	}


  	toString() {
        return this.name;
    }

    setFloors(floors){
    	  this.selectedFloors = floors;
    }

    getFloors(){
        return this.selectedFloors;
    }

    setType(type){
    	  this.type = type;
    }

    isLift(){
      return this.type == "lift" ? true:false;
    }

    

}


export { Rules , NodeType};